import * as S from "../../Style/Page/Car.style.js";
import { Link } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/icon/home.svg";
import Arrow from "../../assets/icon/lnb_arrow.png";
import PageTitle from "../../Component/PageTitleCar.js";
import Mapimg from "../../assets/car/01. 자동차사업 국내지도.png";
import HatPageTopLine from "../../Component/CarPageTopLine.js";
const Introduce = () => {
  return (
    <S.Page className={localStorage.getItem("language")}>
      <HatPageTopLine name={"자동차판매사업"} />
      <section className="section" id="hat-introduce-section">
        <S.PageNavidation>
          <Link to="/" className="logo">
            <Home />
          </Link>
          <S.Nav height={"364px"}>
            <S.NavItem>
              <div className="kor">자동차사업</div>
              <div className="eng">Car Business</div>
            </S.NavItem>

            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">지게차사업</div>
                  <div className="eng">ForkLift Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">자동차사업</div>
                  <div className="eng">Car Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">버스사업</div>
                  <div className="eng">Bus Business</div>
                </Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/introduce">
                  <div className="kor">일반사업</div>
                  <div className="eng">General Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">사회사업</div>
                  <div className="eng">Social Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"156px"}>
            <S.NavItem>
              <Link to="/CarBusiness/introduce">
                <div className="kor">한국 자동차판매사업</div>
                <div className="eng">Korean Automobile sale Business</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">한국 자동차판매사업</div>
                  <div className="eng">Korean Automobile sale Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/AsService">
                  <div className="kor">AS정비사업</div>
                  <div className="eng">AS maintenance business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/CarBusinessHistory">
                  <div className="kor">자동차사업이력</div>
                  <div className="eng">Major business history</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
        </S.PageNavidation>
        <div className="wrap">
          <div className="inner">
            <PageTitle
              titleko={"사업개요"}
              titleeng={"Automobile sale Business"}
              link={"http://www.dm.co.kr/"}
            />
            <div className="page-text">
              <div className="kor">
                1993년 대우자동차㈜로부터 영업부문을 분리, 대우자동차판매㈜가
                설립되었고 2012년 영안 계열사로 편입되었습니다. 영안은 2012년
                대우자동차판매(주)를 인수하여 버스 판매사업과 자동차 정비사업,
                렌터카사업 등을 진행해 왔습니다. 현재는 승용차, 버스, 트럭,
                수입차 등 토털 정비가 가능한 전국 대형 정비사업소 12개 법인을
                운영하고 있고, 렌터카 사업은 본사 및 7개 영업소로 국산차 및
                수입차 500여 대를 운영하고 있습니다. 2022년 7월 국내 버스공장
                생산 중단으로 2024년 4월 부터는 국내 판매사업도 중단하게
                되었습니다.
              </div>
              <div className="eng">
                In 1993, the business division separated from Daewoo Motor Co.,
                Ltd., leading to the establishment of Daewoo Motor Sales Co.,
                Ltd. In 2012, it became a subsidiary of the YoungAn Group.
                YoungAn acquired Daewoo Motor Sales Co., Ltd. in 2012, engaging
                in bus sales, car maintenance services, and car rental
                operations. <br />
                Currently, we operate 12 large-scale maintenance facilities
                nationwide capable of total maintenance for passenger cars,
                buses, trucks, imported vehicles, etc. Additionally, we run a
                car rental business with headquarters and 7 branches operating
                around 500 domestic and imported vehicles. Due to the cessation
                of domestic bus factory production in July 2022, our domestic
                sales operations have also ceased since April 2024.
              </div>
            </div>

            <PageTitle titleko={"사업자 현황"} titleeng={"Business Status"} />
            <div className="page-text">
              <div className="kor">
                <strong>A/S 정비사업</strong>
                <br />
                승용차, 버스, 트럭, 수입차 등 토털 정비 가능한 전국 12곳 직영
                정비사업소를 보유하고 있습니다.
                <br />
                정비처리 능력은 연간 23만대 입니다.
                <br />
                <br />
                <strong>렌터카 사업</strong>
                <br />
                본사 및 7개 영업소로 국산차 및 수입차 500여대를 운영하고
                있습니다.
                <br />
                <br />
                <strong>A/S 부품 사업</strong>
                <br />
                한국에서 운행중인 약 2만 5천여대 자일대우버스 부품 공급을 위해
                전국 55개 대리점을 운영하고 있습니다.
                <br />
                <br />
                <strong>자동차 판매</strong>
                <br />
                1993년 판매회사 신설이후 현재까지 승용차, 버스, 트럭, 수입차 등
                다양한 브랜드의
                <br />
                자동차 판매사업을 하였습니다.
              </div>
              <div className="eng">
                <strong>A/S Maintenance Operations</strong>
                <br />
                We own and operate 12 directly-managed maintenance facilities
                nationwide capable of total maintenance for passenger cars,
                buses, trucks, and imported vehicles.
                <br />
                Our maintenance processing capacity is approximately 230,000
                units annually.
                <br />
                <br />
                <strong>Car Rental Business</strong>
                <br />
                We operate approximately 500 domestic and imported vehicles
                through our headquarters and 7 branches.
                <br />
                <br />
                <strong>A/S Parts Business</strong>
                <br />
                To supply parts for around 25,000 Daewoo buses in operation in
                Korea,
                <br />
                we operate 54 dealerships nationwide.
                <br />
                <br />
                <strong>Automotive sales</strong>
                <br />
                Since the establishment of the sales company in 1993 up to now
                the company has been engaged in
                <br />
                the sales cars and Commercial bus
              </div>
            </div>
            <img className="fullsize-map" src={Mapimg} alt="" />
          </div>
        </div>
      </section>
    </S.Page>
  );
};

export default Introduce;
